'use client';

import { WarningFilled } from '@drift-labs/icons';
import { getColorVar } from 'src/utils/theme/colorVars';

function BankruptAccountWarning() {
	return (
		<div className="flex flex-col items-center justify-center gap-y-xl">
			<div className="flex flex-col items-center justify-center gap-y-sm">
				<WarningFilled color={getColorVar('star-yellow')} size={56} />
				<h3 className="typo-t1 text-text-default">
					Your account was liquidated
				</h3>
			</div>
			<p className="typo-b3 text-text-secondary">
				Your account now has a negative balance. Deposits are temporarily paused
				while we resolve this using the Insurance Fund.
			</p>
		</div>
	);
}

export default BankruptAccountWarning;
